var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style["m-market"], staticStyle: { overflow: "hidden" } },
    [
      _c("div", { staticClass: "m-container" }, [
        _c("div", { class: _vm.$style["container-inner"] }, [
          _c(
            "div",
            {
              ref: "listWrapper",
              class: _vm.$style["price-list"],
              on: { pointerenter: _vm.pause, pointerleave: _vm.play }
            },
            [
              _c(
                "div",
                {
                  ref: "listBox",
                  staticClass: "flex",
                  class: _vm.$style["list-inner"]
                },
                _vm._l(_vm.runList, function(item, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      class: _vm.$style["list-item"],
                      attrs: { href: item.link, target: "_blank" }
                    },
                    [
                      _c(
                        "div",
                        { class: _vm.$style["item-title"] },
                        [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(
                                decodeURI(item.symbol) +
                                  " $" +
                                  item.recentQuotation +
                                  "(" +
                                  item.change +
                                  ")"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("UeIcon", {
                            class: _vm.$style["ic"],
                            attrs: { name: "long-arrow-right" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-149e834f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-149e834f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/MarketModule.vue
// module id = 5Iov
// module chunks = 0